"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertProcessToNodeMap = void 0;
var nodemap_generics_1 = require("../nodemap/nodemap-generics");
function convertProcessToNodeMap(content) {
    return nodemap_generics_1.convertListOfStepsToNodeMap(content);
}
exports.convertProcessToNodeMap = convertProcessToNodeMap;
